import { Trans, useLingui } from '@lingui/react'
import './FilterBoxSortingBar.scss'
import type { SearchState } from 'react-instantsearch-core'
import { connectStateResults } from 'react-instantsearch-dom'

import FlyoutSortBy from 'shared/experiments/components/NewSerp/FlyoutSortBy'
import {
  getDefaultHitsPerPage,
  getSortingItemsV1,
} from 'shared/utils/algolia/filters'
import type { SortingItem } from 'shared/utils/algolia/types'
import type { SearchResults } from 'types/search'
import { getHitsPerPageItems } from 'views/components/organisms/AlgoliaInstantSearch/Algolia/helpers'
import HitsPerPage from 'views/components/organisms/AlgoliaInstantSearch/Algolia/HitsPerPage'

const getSelectedSortingLabel = ({
  sortingItems,
  sortBy,
  fallbackText,
}: {
  sortingItems: SortingItem[]
  sortBy?: string
  fallbackText: string
}): string => {
  const sortingItem = sortingItems.find(item => item.value === sortBy)

  return sortingItem ? sortingItem.label : fallbackText
}

export const FilterBoxSortingBar = connectStateResults(
  ({ indexName, searchState, ...rest }: ComponentProps) => {
    const { i18n } = useLingui()
    const sortingItems = getSortingItemsV1({
      indexName,
      i18n,
      isSearchResultsPage: true,
    })
    const hitsPerPageItems = getHitsPerPageItems()
    const defaultHitsPerPage = getDefaultHitsPerPage(rest.searchResults)

    return (
      <div className="e-filter-box-sorting-bar">
        <div className="e-filter-box-sorting-bar__page-hits">
          {hitsPerPageItems && hitsPerPageItems.length > 0 && (
            <li
              className="u-padding--right"
              data-qa-id="results-per-page-select"
            >
              <HitsPerPage
                items={hitsPerPageItems}
                defaultRefinement={defaultHitsPerPage}
                label={i18n._('general.label.sort.Anzeigen')}
              />
            </li>
          )}
        </div>
        <div className="e-filter-box-sorting-bar__sort">
          <span className="u-font-weight-rebranding--medium">
            <Trans id="general.headline.sort" />:
          </span>
          <FlyoutSortBy
            label={getSelectedSortingLabel({
              sortingItems,
              sortBy: searchState.sortBy,
              fallbackText: i18n._('general.headline.sort'),
            })}
            indexName={indexName}
            items={sortingItems}
          />
        </div>
      </div>
    )
  }
)

type ComponentProps = {
  searchResults: SearchResults
  indexName: string
  searchState: SearchState
}
